import WordFadeIn from "./WordFadeIn";
import DrawIcon from "./DrawIcon";

interface PageHeaderProps {
  tag: string;
  title: string;
  subtitle?: string;
  heroImage?: string;
  drawIconVariant?: "cart" | "leaf" | "heart" | "store" | "star";
  objectPosition?: string;
}

const PageHeader = ({ tag, title, subtitle, heroImage, drawIconVariant, objectPosition = "center top" }: PageHeaderProps) => (
  <section
    className="relative flex items-center pt-32 pb-16 md:pt-32 md:pb-20 px-6 md:px-16 overflow-hidden min-h-[70vh] md:min-h-[560px] md:h-[560px]"
    aria-label={tag}
  >
    {heroImage && (
      <>
        <img
          src={heroImage}
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
          style={{ objectPosition }}
          loading="eager"
          aria-hidden="true"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-background/90 via-background/70 to-background/85" />
      </>
    )}

    {drawIconVariant && (
      <DrawIcon
        variant={drawIconVariant}
        size={180}
        delay={1}
        className="absolute right-8 md:right-20 top-1/3 z-10 opacity-20 hidden md:block"
      />
    )}

    <div className="relative z-10 w-full max-w-5xl mx-auto text-center md:text-left">
      <WordFadeIn
        text={tag}
        as="p"
        className="font-body text-sm text-primary-bright tracking-[0.3em] uppercase mb-4"
        staggerDelay={0.06}
      />
      <WordFadeIn
        text={title}
        as="h1"
        className="font-display text-4xl md:text-6xl lg:text-7xl font-bold text-foreground leading-tight [hyphens:none]"
        delay={0.2}
        staggerDelay={0.1}
      />
      {subtitle && (
        <WordFadeIn
          text={subtitle}
          as="p"
          className="mt-6 text-lg md:text-xl text-muted-foreground font-body max-w-2xl mx-auto md:mx-0 leading-relaxed"
          delay={0.6}
          staggerDelay={0.04}
        />
      )}
    </div>
  </section>
);

export default PageHeader;
